import React from 'react';
import './FooterStyles.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* <img src={`${process.env.PUBLIC_URL}/alcaldia.png`} alt="BILLBOARD APP Logo" className="footer-logo" /> */}
        <p>&copy; 2025 BILLBOARD. All rights reserved.</p>
        {/* <img src={`${process.env.PUBLIC_URL}/LOGO-SISC-V.png`} alt="SISC Logo" className="footer-logo" /> */}
      </div>
    </footer>
  );
};

export default Footer;